export default function onSelectAll(event, editor) {
  event.preventDefault();
  var startBlock = editor.value.startBlock;
  editor.selectTableCell(startBlock);
  return false;
}